import { useCopyToClipBoard } from "hooks/useCopyToClipBoard";
import Action from "pages/_components/Action";
import Button from "pages/_components/Button";
import CustomData from "pages/_components/CustomData/CustomData";
import GridTable from "pages/_components/GridTable/GridTable";
import { DesktopButtons, MobileButtons, ResponsiveHeader } from "pages/_components/header";
import I18n from "pages/_components/I18n";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { actions as contactActions } from "reducers/contactDestination";
import { isIOS } from "react-device-detect";
import { useListContacts } from "./hooks/useListContacts";
import useTransferByCbu from "./hooks/useTransferByCbu";

const ContactDetailsPage = ({ isDesktop }) => {
    const { selectedContact, fetching, dispatch } = useListContacts({ loadDetail: true });
    const { handleOtherTransfer } = useTransferByCbu();
    const { handleCopyToClipBoard } = useCopyToClipBoard(
        isDesktop,
        "transfer.frequentDestinations.textCopy",
        selectedContact,
    );

    const options = [
        {
            text: "frequentDestinations.contextMenu.transfer",
            textType: "I18N",
            func: () => handleOtherTransfer(selectedContact),
        },
        {
            text: "frequentDestinations.contextMenu.share",
            textType: "I18N",
            func: () => handleCopyToClipBoard("FrequentDestinations"),
        },
    ];

    const handleClick = () => {
        dispatch(
            contactActions.deleteFrequentDestinationPreviewRequest({
                idFrequentDestination: selectedContact.idFrequentDestination,
            }),
        );
    };
    return (
        <>
            <Notification scopeToShow="FrequentDestinations" />
            <ResponsiveHeader defaultTitle={selectedContact.name}>
                <DesktopButtons moreOptions={options}>
                    <Button className="btn btn-outline" label="global.delete" onClick={handleClick} />
                    <Link
                        className="btn btn-primary btn-block"
                        to={`/contactDestination/modify/${selectedContact.idFrequentDestination}`}>
                        <I18n id="global.modify" />
                    </Link>
                </DesktopButtons>
                <MobileButtons
                    image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                    <Action labelKey="global.delete" handleClick={handleClick} />
                    <Action
                        labelKey="global.modify"
                        to={`/contactDestination/modify/${selectedContact.idFrequentDestination}`}
                    />
                    <Action
                        labelKey="frequentDestinations.contextMenu.transfer"
                        handleClick={() => handleOtherTransfer(selectedContact)}
                    />
                    <Action
                        labelKey="frequentDestinations.contextMenu.share"
                        handleClick={() => handleCopyToClipBoard("FrequentDestinations")}
                    />
                </MobileButtons>
            </ResponsiveHeader>
            <MainContainer showLoader={fetching}>
                <GridTable className="form-summary contact">
                    <GridTable.Container>
                        <CustomData
                            titleText="transfer.frequentDestination.creditAccount"
                            titleTextType="I18N"
                            valueText={selectedContact.accountNumber}
                        />
                        <GridTable.Data columnStart={2} rowStart={1}>
                            <CustomData
                                titleText="transfer.frequentDestination.cbucvu"
                                titleTextType="I18N"
                                valueText={selectedContact.cbu}
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={3} rowStart={1}>
                            <CustomData
                                titleText="transfer.frequentDestination.localBank"
                                titleTextType="I18N"
                                valueText={selectedContact.localBank}
                            />
                        </GridTable.Data>

                        <GridTable.Data columnStart={1} rowStart={2}>
                            <CustomData
                                titleText="accounts.create.accountType"
                                titleTextType="I18N"
                                valueText={`${selectedContact?.productType?.replace("ARS", "$")}`}
                            />
                        </GridTable.Data>

                        <GridTable.Data columnStart={2} rowStart={2}>
                            <CustomData
                                titleText="transfer.frequentDestination.document"
                                titleTextType="I18N"
                                // eslint-disable-next-line max-len
                                valueText={`${selectedContact.recipientDocumentType} ${selectedContact.recipientDocumentNumber}`}
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={3} rowStart={2}>
                            <CustomData
                                titleText="transfer.frequentDestination.recipientEmail"
                                titleTextType="I18N"
                                valueText={selectedContact.recipientEmail}
                            />
                        </GridTable.Data>

                        <GridTable.Data columnStart={1} rowStart={4}>
                            <CustomData
                                titleText="transfer.frequentDestination.isOwn"
                                titleTextType="I18N"
                                valueText={selectedContact.isOwn === "1" ? "global.yes" : "global.no"}
                                valueTextType="I18N"
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={2} rowStart={4}>
                            <CustomData
                                titleText="transfer.frequentDestination.recipientName"
                                titleTextType="I18N"
                                valueText={selectedContact.recipientName}
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={3} rowStart={4}>
                            <CustomData
                                titleText="forms.transferInternal.confirmation.reference"
                                titleTextType="I18N"
                                valueText={selectedContact.name}
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
            </MainContainer>
        </>
    );
};

ContactDetailsPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default ContactDetailsPage;
